// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
    "limit": 10,
    "offset": 0,
    "live_orders": [
         {
            "order_crn": "CRN0000000001",
            "geo_region_id": null,
            "order_status": "LIVE",
            "order_created_at": 1719228428495,
            "type": "Courier",
            "service_details": {
                "vehicle_id": null,
                "name": "All India Parcel",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/ni-images/icon-images/courier.png",
                "service_type": "Courier"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Test Doorstep",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Test Doorstep",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 0.0
            },
            "tracking_link": null,
            "payment_mode": null,
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
      {
            "order_crn": "CRN0000000002",
            "geo_region_id": 3,
            "order_status": "LIVE",
            "order_created_at": 1713523201000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 2,
                "name": "Tata 407",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Tata_407_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": null,
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Test Doorstep",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 869.0
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN0000000003",
            "geo_region_id": 3,
            "order_status": "LIVE",
            "order_created_at": 1713522523000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": null,
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Test Doorstep",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 400.0
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        },
    ],
    "past_orders": [
        {
            "order_crn": "CRN0000000004",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712728800000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 9,
                "name": "Pickup 8ft",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Pickup_8ft_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 392.55
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN0000000005",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712664234000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 218.91
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        },
        {
            "order_crn": "CRN0000000006",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712581759000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 218.91
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        },
        {
            "order_crn": "CRN0000000007",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712581474000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 24,
                "name": "3 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/3_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 128.57
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN0000000008",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712310018000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 2,
                "name": "Tata 407",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Tata_407_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Test Doorstep",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Test Doorstep",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 822.66
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN0000000009",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712227886000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 24,
                "name": "3 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/3_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 128.57
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN0000000010",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712225940000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 2,
                "name": "Tata 407",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/Tata_407_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 810.41
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": false
        },
        {
            "order_crn": "CRN0000000011",
            "geo_region_id": 3,
            "order_status": "CANCELLED",
            "order_created_at": 1712208071000,
            "type": "OnDemand",
            "service_details": {
                "vehicle_id": 83,
                "name": "2 Wheeler",
                "icon_url": "https://porter-vehicles.s3.ap-southeast-1.amazonaws.com/icon-images/images_2.0/2_Wheeler_selected.png",
                "service_type": "OnDemand"
            },
            "vas_type": null,
            "is_business_customer": false,
            "route_details": {
                "source": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": null,
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "destination": {
                    "location": {
                        "lat": 0.0,
                        "long": 0.0
                    },
                    "contact": {
                        "name": "Test User",
                        "number": "9999999999"
                    },
                    "place": {
                        "doorstep_address": "Test Doorstep",
                        "saved_address_name": null,
                        "saved_address_uuid": null,
                        "address": "Test Address, Bengaluru, Karnataka, India"
                    }
                },
                "waypoint_info": {
                    "count": 0,
                    "waypoints": [],
                    "restriction": null
                }
            },
            "total_amount": {
                "currency": "₹",
                "amount": 0.0,
                "cash_payable": 221.66
            },
            "tracking_link": "oms-staging-1.porter.in/rd/placeholder",
            "payment_mode": "PAYMENT_MODE_CASH",
            "pay_online_enabled": false,
            "rebooking_enabled": true,
            "muneemji_enabled": true
        }
    ]
};

export {
  dummyResponse ,
}
/* No side effect */
